import { ReactNode } from "react";

type Props = {
  color: string;
  children: ReactNode;
};

export default function ShopBody({ color, children }: Props) {
  return (
    <div
      data-mz-accent={color}
      className="flex flex-col min-h-0 grow shrink w-[70.75rem] max-h-[52rem] bg-dark-900 bg-[length:16rem_16rem] bg-[position:0_0] bg-no-repeat 
            bg-gradient-to-br from-accent-solid/20 from-0% to-transparent to-50% rounded-4"
    >
      {children}
    </div>
  );
}
